import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./PaymentCreditCardForm";
import {cancelSetPaymentCreditCard} from "../../actions/AccountApiActions";
import {Map} from "immutable";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  return errors.toJS();
}

class SetPaymentCreditCardFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.changePaymentMethodToCreditCard(this.props.accountId)
      .then((response) => {
        if (response.data.changePaymentMethodToCreditCard.errors.length <= 0) {
          this.props.cancelSetPaymentCreditCard();
        } else {
          let errors = createValidationErrors(response.data.changePaymentMethodToCreditCard.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelSetPaymentCreditCard();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    );
  }
}


const CHANGE_PAYMENT_METHOD = gql`
  mutation changePaymentMethodToCreditCard($accountId: ID!) {
    changePaymentMethodToCreditCard(accountId: $accountId) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(CHANGE_PAYMENT_METHOD, {
    props: ({ mutate }) => ({
      changePaymentMethodToCreditCard: (accountId) => mutate({
        variables: { accountId: accountId }
      })
    })
  })  
);


export default connect(null, {cancelSetPaymentCreditCard})(withQueries(SetPaymentCreditCardFormContainer));